import { businessKey } from 'queryKeys';

import { model } from 'scenes/Gallery/GalleryPage/Concepts/data/queryKeyFactory';

const CREATIVE_SHARE_MUTATION = 'creativeShareMutation';
const SHARE = 'share';

const shareQuery = businessKey.query(SHARE);
export const list = (conceptId) => [...model(conceptId), SHARE];

export const mutations = shareQuery.query(CREATIVE_SHARE_MUTATION).mutations();
export const update = mutations.update();
